"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TITLES = exports.ORDER_STATUSES = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _TITLES;
var ORDER_STATUSES = exports.ORDER_STATUSES = {
  APPROVED: 'approved',
  BOOKED: 'booked',
  CANCELED: 'canceled',
  CONFIRMED: 'confirmed',
  CREATED: 'created',
  DEPOSIT: 'deposit',
  DOCUMENTS_SENT: 'documents_sent',
  FLIGHT_CONFIRMED: 'flight_confirmed',
  GOT_BACK: 'got_back',
  NOT_CONFIRMED: 'not_confirmed',
  ON_TRIP: 'on_trip',
  PAID: 'paid',
  SURVEY_COMPLETED: 'survey_completed'
};
var TITLES = exports.TITLES = (_TITLES = {}, (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_TITLES, ORDER_STATUSES.APPROVED, 'начат'), ORDER_STATUSES.BOOKED, 'бронь оформ.'), ORDER_STATUSES.CANCELED, 'отменен'), ORDER_STATUSES.CONFIRMED, 'подтвержден'), ORDER_STATUSES.DEPOSIT, 'депозит'), ORDER_STATUSES.DOCUMENTS_SENT, 'док. высл.'), ORDER_STATUSES.FLIGHT_CONFIRMED, 'рейс ОК'), ORDER_STATUSES.GOT_BACK, 'прилетел'), ORDER_STATUSES.NOT_CONFIRMED, 'отказ ТО'), ORDER_STATUSES.ON_TRIP, 'отдыхает'), (0, _defineProperty2["default"])((0, _defineProperty2["default"])((0, _defineProperty2["default"])(_TITLES, ORDER_STATUSES.CREATED, 'новый'), ORDER_STATUSES.PAID, 'оплачен'), ORDER_STATUSES.SURVEY_COMPLETED, 'опрошен'));